import React, { useContext, useEffect, useState } from "react";
import Layout from "../Layout/layout";
import { StanContext } from "../context";
import stanoviData from "../../assets/stanoviData.js";
import Iskustvo from "../Sections/Iskustvo";
import Benefits from "../Sections/Benefits";
import { Link } from "react-router-dom";

const StanNumberSelectPage = () => {
  const { ulaz, stanType, setFullStan } = useContext(StanContext);
  const [data, setData] = useState([]);
  const [lamela, setLamela] = useState(null);
  const [type, setType] = useState();
  const [stanArray, setStanArray] = useState([]);
  const [dep, setDep] = useState(false);
  useEffect(() => {
    if (ulaz === "A") {
      setLamela("lamelaA");
    } else if (ulaz === "B") {
      setLamela("lamelaB");
    } else {
      setLamela(null);
    }

    if (lamela) {
      setData(stanoviData[lamela]);
    } else {
      setData(stanoviData);
    }

    setType(stanType?.toLowerCase());

    if (lamela && type) {
      setStanArray(data[type]);
    } else if (type) {
      if (data.lamelaA[type] && data.lamelaB[type]) {
        setStanArray(data.lamelaA[type].concat(data.lamelaB[type]));
      } else if (!data.lamelaA[type]) {
        setStanArray(data.lamelaB[type]);
      } else if (!data.lamelaB[type]) {
        setStanArray(data.lamelaA[type]);
      }
      setDep(true);
    }
  }, [ulaz, lamela, data, type, stanType, dep]);

  return (
    <Layout>
      <div className="relative z-10 bkg flex flex-col items-center">
        <div className="w-full flex justify-center items-center bg-teal-300 py-12">
          <h1 className="text-white lg:text-4xl text-2xl mt-24 md:mt-0 text-center">
            {ulaz && "ULAZ " + ulaz + " - "} {stanType?.toUpperCase()}{" "}
          </h1>
        </div>
        <div
          className={
            stanArray?.length <= 1
              ? "w-[80%] py-8 flex justify-center items-center"
              : "w-[80%] py-8 grid gap-8 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 place-items-center "
          }>
          {stanArray?.map((el, i) => {
            const brojevi = el.name.substring(
              el.name.indexOf("(") + 1,
              el.name.indexOf(")")
            );
            return (
              <div
                key={i}
                className={
                  stanArray.length === 1
                    ? "border-2 border-solid border-teal-600 bg-white py-4 text-xl lg:w-[33%] relative"
                    : "border-2 border-solid border-teal-600 bg-white py-4 text-xl relative"
                }
                onClick={() => {
                  setFullStan(el);
                }}>
                {el.dostupnost.every((el) => el.prodat === "DA") && (
                  <div className="w-full h-full absolute top-0 left-0 bg-gray-600 opacity-60">
                    <span className="absolute top-[50%] left-[50%] transform translate-x-[-50%] translate-y-[-50%] -skew-y-12 text-4xl text-red-700">
                      ZAUZETO
                    </span>
                  </div>
                )}
                <Link to="/apartment">
                  <h1 className="text-center">STANOVI BR.</h1>
                  <h1 className="text-center">{brojevi}</h1>
                  <p className="text-center pb-4">
                    POVRŠINA STANA:{" "}
                    <span className="font-bold">{el.površinaStana}</span> m
                    <sup>2</sup>
                  </p>
                  <img src={el.imgUrl} alt="slika" />
                  {!lamela && (
                    <p className="text-center mt-4">ULAZ {el.ulaz}</p>
                  )}
                </Link>
              </div>
            );
          })}
        </div>
        <Iskustvo />
        <Benefits />
      </div>
    </Layout>
  );
};

export default StanNumberSelectPage;
